import { useEffect } from 'react';

const OVERLAY_SELECTOR = '[data-pr-is-overlay="true"]';

const isHTMLElement = (node: Node): node is HTMLElement => {
  return node instanceof HTMLElement;
};

const repaintOverlay = (el: HTMLElement) => {
  const current =
    el.style.getPropertyValue('--_pr-repaint') === '1' ? '0' : '1';
  el.style.setProperty('--_pr-repaint', current);
};

// Workaround for a Chromium compositing bug where PrimeReact overlays are sometimes inserted into the DOM but not painted; mutating a trivial CSS property forces a repaint so dropdown panels reliably become visible.
// Without this we would have cases where dropdowns don't appear open and are not usable for the user
export const PrimeReactOverlayRepaintPatch = () => {
  useEffect(() => {
    const handleNode = (node: Node) => {
      if (!isHTMLElement(node)) {
        return;
      }

      if (node.matches(OVERLAY_SELECTOR)) {
        repaintOverlay(node);
        return;
      }

      const overlays = node.querySelectorAll<HTMLElement>(OVERLAY_SELECTOR);

      overlays.forEach(repaintOverlay);
    };

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (!record.addedNodes.length) {
          return;
        }

        record.addedNodes.forEach(handleNode);
      });
    });

    observer.observe(document.body, {
      childList: true,
      // subtree: false is enough; PrimeReact overlays are direct body children
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
};
